import * as React from 'react';
import {Text, View} from 'react-native';
import {Screens} from '../../../../../routing';
import {Link} from '../../../../link';
import {CardBlockedMessageViewProps} from '../model';

const CardBlockedMessageMobile = ({
  canReissueCard,
  showReissueHintBelow,
  navigate,
  styles,
}: CardBlockedMessageViewProps) => {
  if (!canReissueCard || showReissueHintBelow) {
    return (
      <Text style={[styles.message, styles.messageWithIconGap]} testID='notification-card-blocked-title'>
        Ваша карта заблокирована.
      </Text>
    );
  }

  return (
    <View style={styles.messageStack} testID='notification-card-blocked-title'>
      <Text style={styles.message}>Ваша карта заблокирована. Вы можете </Text>
      <View style={{flexDirection: 'row', flexShrink: 0, alignItems: 'center'}}>
        <Link
          testID='notification-card-blocked-reissue-link'
          screen={Screens.Profile}
          screenParams={{screen: Screens.ProfileSafety}}
          navigate={navigate}
          textStyle={styles.link}>
          перевыпустить ЕСК
        </Link>
        <Text style={styles.message}>.</Text>
      </View>
    </View>
  );
};

export default CardBlockedMessageMobile;
